import React from 'react';
import PropTypes from 'prop-types';

const Close = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M12.9,12l4.9-4.9c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L12,11.1L7.1,6.2C6.9,6.1,6.8,6,6.6,6
            C6.5,6,6.3,6.1,6.2,6.2C6,6.5,6,6.8,6.2,7.1l4.9,4.9l-5,5c-0.2,0.2-0.2,0.6,0,0.9s0.6,0.2,0.9,0l5-5l4.9,4.9c0.2,0.2,0.6,0.2,0.9,0
            c0.2-0.2,0.2-0.6,0-0.9L12.9,12z"
    />
  </svg>
);

Close.propTypes = {
  className: PropTypes.string,
};

export default Close;
